import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  Input,
  AfterViewInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import {
  NgForm,
  NgModel,
  FormGroup,
  FormBuilder,
  FormControl,
} from '@angular/forms';
import { PersonService } from 'src/app/shared/services/person.service';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/shared/services/product.service';
import { validaCorreo } from '../../helpers/helper';
import { Router, RouterEvent, NavigationStart } from '@angular/router';
import { filter, tap, take } from 'rxjs/operators';
import { DialogStatusMessageComponent } from '../dialog-status-message/dialog-status-message.component';
import { formatDate } from '@angular/common';
import { timer } from 'rxjs';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from '../../enums/insights/event';
import { BiceCrmService } from '@app/shared/services/bice-crm.service';

@Component({
  selector: 'app-dialog-formulario-prima-en-exceso',
  templateUrl: './dialog-formulario-prima-en-exceso.component.html',
  styleUrls: [
    './dialog-formulario-prima-en-exceso.component.sass',
    '../../../../invStyles.sass',
  ],
})
export class DialogFormularioPrimaEnExcesoComponent
  implements OnInit, AfterViewInit {
  primas: string[];
  tipoPrima: string;
  form: FormGroup;
  Email: string;
  Telefono: string;
  UF = 0;
  nCuentaDeposito: string;
  nombreContratante: string;
  rutContratante: string;
  emailContratante: string;
  emailDeposito: string;
  resumen;
  loading = false;
  error = false;
  loadingService = false;
  UfValida = false;
  formularioSinProblemas = false;
  pierdeFocoTelefono = false;
  pierdeFocoMail = false;
  pierdeFocoUF = false;
  errorFormulario = false;
  successMessage = false;
  ValorPrimaPeriodica: number;
  LineaNegocio: string;

  vidaUrl = environment.url.api + '/';
  mailUrl = environment.service.mail.endpoint_url;

  url = '';
  info: string =
    'Para actualizar el mail al cual recibirás la respuesta, ingresa a la sección "mis datos".';
  mostrarInfo: boolean = true;

  botonSolicitarHabilitado: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DialogFormularioPrimaEnExcesoComponent>,
    private personService: PersonService,
    private productService: ProductService,
    private dialog: MatDialog,
    router: Router,
    private appInsightsService: AppInsightsService,
    private biceCrmService: BiceCrmService
  ) {
    this.url = router.url;

    router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof NavigationStart),
        tap(() => this.dialogRef.close()),
        take(1)
      )
      .subscribe();
    this.primas = ['Aumentar prima en Exceso', 'Disminuir prima en Exceso'];
    this.tipoPrima = this.primas[0];
  }
  change(value) {
    this.tipoPrima = this.primas[value];
  }
  validaCorreo() {
    const CorreoIsValid: boolean = validaCorreo(this.form.get('Email').value);
    if (CorreoIsValid) {
      this.form.get('Email').setErrors(null);
    } else {
      this.form.get('Email').setErrors({ incorrect: true });
    }
    return CorreoIsValid;
  }
  onLostFocus(field) {
    switch (field) {
      case 'Telefono':
        this.pierdeFocoTelefono = true;

        this.validarTelefono();
        break;
      case 'Email':
        this.pierdeFocoMail = true;
        this.validaCorreo();
        break;
    }
  }

  validaUf(campo) {
    const primaValue = campo.toString().replace(',', '.');
    if (!primaValue) {
      this.form.get('UF').setErrors({ incorrect: true });
      return 'Debe ingresar al menos un dígito';
    } else {
      if (primaValue >= 100) {
        this.form.get('UF').setErrors({ incorrect: true });
        return 'El monto ingresado no debe ser superior a 99,9999';
      } else if (primaValue < 0.5) {
        this.form.get('UF').setErrors({ incorrect: true });
        return 'Tu nueva prima periódica no puede ser menor a 0,5 UF';
      } else if (primaValue <= '.99999') {
        this.form.get('UF').setErrors({ incorrect: true });
        return 'Debe ingresar un monto válido';
      } else if (this.filter(primaValue) === true) {
        this.form.get('UF').setErrors({ incorrect: true });
        return 'Debe ingresar un monto válido';
      } else {
        this.form.get('UF').setErrors(null);
        return 'OK';
      }
    }
  }

  filter(prima) {
    const preg = /,{1,6}/;

    if (preg.test(prima) === true) {
      return true;
    } else {
      return false;
    }
  }

  getErrorMessage(form, field) {
    const campo = form.get(field);
    if (campo.value) {
      if (field === 'Email') {
        if (!this.validaCorreo()) {
          return 'El correo ingresado no es válido.';
        }
      }
      if (field === 'Telefono') {
        if (!this.validarTelefono()) {
          return 'Ingrese un valor válido.';
        }
      }

      if (field === 'UF') {
        const res = this.validaUf(campo.value);
        if (res !== 'OK') {
          return res;
        }
      }
      return '';
    }
  }
  limpiarFormulario() {
    this.form = new FormGroup({
      Email: new FormControl(),
      Telefono: new FormControl(),
      UF: new FormControl(),
    });
  }
  ngOnInit() {
    this.LineaNegocio = this.data.LineaNegocioPE;
    this.loading = true;
    this.error = false;
    this.limpiarFormulario();

    const dataSubs = this.personService
      .getDatosContratanteProducto(this.data.idPoliza, 'INDIVIDUAL', '')
      .subscribe(
        data => {
          console.log(
            'endoso prima en exceso data contratante disponible',
            data
          );
          this.emailDeposito = data.Correo;
        },

        error => {
          this.error = true;
          this.dialogRef.close();
          this.dialog.open(DialogStatusMessageComponent, {
            minWidth: '20vw',
            disableClose: true,
            data: {
              title: 'Ha ocurrido un problema',
              message: 'Intentelo de nuevo más tarde.',
              error: true,
            },
          });
        }
      );

    this.personService.getAsegurados(this.data.idPoliza).subscribe(
      data => {
        this.loading = false;
        this.ValorPrimaPeriodica = 0;
        for (const asegurado of data[1]) {
          this.ValorPrimaPeriodica += asegurado.PrimaBruta;
        }
      },
      error => {
        this.loading = false;
        this.dialogRef.close();
        this.dialog.open(DialogStatusMessageComponent, {
          minWidth: '20vw',
          disableClose: true,
          data: {
            title: 'Ha ocurrido un problema',
            message: 'Intentelo de nuevo más tarde.',
            error: true,
          },
        });
      }
    );
  }
  ngAfterViewInit() {
    this.limpiarFormulario();
    const dataSubs = this.personService
      .getDatosContratanteProducto(this.data.idPoliza, 'INDIVIDUAL', '')
      .subscribe(
        data => {
          this.nombreContratante = data.Nombre;
          this.rutContratante = data.Rut;
          this.emailContratante = data.Correo;
          this.Email = data.Correo;
        },

        error => {
          this.error = true;
          this.dialogRef.close();
          this.dialog.open(DialogStatusMessageComponent, {
            minWidth: '20vw',
            disableClose: true,
            data: {
              title: 'Ha ocurrido un problema',
              message: 'Intentelo de nuevo más tarde.',
              error: true,
            },
          });
        }
      );
  }
  validarTelefono() {
    const telefono = this.form.get('Telefono').value;
    if (telefono.length === 9) {
      this.form.get('Telefono').setErrors(null);
    } else {
      this.form.get('Telefono').setErrors({ incorrect: true });
    }
    return telefono.length === 9;
  }

  onSubmit() {
    this.botonSolicitarHabilitado = false;
    this.appInsightsService.trackEvent(Event.iideBtnRequestEndorsement);
    this.loadingService = true;
    this.pierdeFocoTelefono = false;
    this.pierdeFocoMail = false;
    this.pierdeFocoUF = false;
    const Description = '';
    const casoCategoriaC = 'Endoso IND';
    const aumdism = 'ED - Endoso Aumento de Prima en Exceso';
    const subject = aumdism;

    const tipoSolicitante = 'Contratante';
    const subject_Email = 'Solicitud de Endoso Prima en Exceso';
    let valorPrima = this.form.get('UF').value;
    valorPrima = valorPrima.toString().replace(',', '.');

    //llamada salesforce bice
    let fnacimiento = '2000-01-01T10:49:19.091Z';
    let desc =
      aumdism +
      ' - ' +
      ' Nombre Contratante:' +
      this.nombreContratante +
      ' Telefono:' +
      this.form.get('Telefono').value +
      ' Valor Prima:' +
      valorPrima.toString() +
      ' Valor Prima Periodica:' +
      this.ValorPrimaPeriodica.toString() +
      ' Valor Prima Total:' +
      this.form.get('UF').value +
      ' Rut Contratante:' +
      this.rutContratante;

    var consultationReason = 'Mantencion -S.Individuales';
    var consultationDetail = 'Recalculo de Prima';
    var businessLine = 'Seguros individuales';

    try {
      this.biceCrmService
        .crearCaso(
          fnacimiento,
          this.form.get('Telefono').value,
          this.form.get('Telefono').value,
          desc,
          consultationReason,
          consultationDetail,
          businessLine,
          consultationDetail,
          this.data.idPoliza.toString(),
          []
        )
        .subscribe(resp => {
          console.log('create case bice - endoso prima en exceso', resp);
          this.botonSolicitarHabilitado = false;

          if (resp.CrmBiceCaseId) {
            this.form.disable();
            this.loadingService = true;
            this.errorFormulario = false;
            this.formularioSinProblemas = false;

            const date = new Date();
            const dateStr = formatDate(date, 'dd/MM/yyyy', 'es-cl');
            const typeForm = 4;
            const primaExcesoType =
              this.tipoPrima === 'Aumentar prima en Exceso'
                ? 'AUMENTO'
                : 'DISMINUCIÓN';
            this.productService
              .postSendMail(
                resp.CrmBiceCaseId,
                typeForm,
                this.nombreContratante,
                dateStr,
                primaExcesoType,
                this.data.idPoliza
              )
              .subscribe(
                response => {
                  this.botonSolicitarHabilitado = false;
                  if (!response.response.status) {
                    this.dialog.open(DialogStatusMessageComponent, {
                      minWidth: '20vw',
                      disableClose: true,
                      data: {
                        title: 'Ha ocurrido un problema',
                        message: 'Intentelo de nuevo más tarde.',
                        error: true,
                      },
                    });
                    this.loadingService = false;
                    this.limpiarFormulario();
                  } else {
                    this.form.disable();
                    this.form.enable();
                    this.loadingService = false;
                    this.limpiarFormulario();
                    timer(5000).subscribe(x => {
                      this.formularioSinProblemas = true;
                    });
                  }
                },
                () => {
                  this.botonSolicitarHabilitado = false;
                  this.dialog.open(DialogStatusMessageComponent, {
                    minWidth: '20vw',
                    disableClose: true,
                    data: {
                      title: 'Ha ocurrido un problema',
                      message: 'Intentelo de nuevo más tarde.',
                      error: true,
                    },
                  });
                }
              );
          } else {
            this.botonSolicitarHabilitado = false;
            this.errorFormulario = true;
          }
        });
    } catch (error) {
      console.log('error crear caso', error);
      this.botonSolicitarHabilitado = false;
    }
  }
  onClose() {
    this.dialogRef.close();
  }

  validarNumerico(field) {
    let valor = parseInt(this.form.get(field).value, 10);
    if (isNaN(valor)) {
      valor = 0;
    }

    this.form.get(field).setValue(valor === 0 ? '' : valor);
    if (valor === 0) {
      this.form.get(field).setErrors({ incorrect: true });
      return false;
    }
    this.form.get(field).setErrors(null);
    return true;
  }

  transformValue() {}
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    if (charCode === 44) {
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  onLostFocusUF() {
    this.pierdeFocoUF = true;
  }
}
